// Pause and resume (spec PF-04). Lagos Life pauses the game when the phone backgrounds or its own
// pay or stake sheet opens over us (Vatar.onPause), and resumes it after. The frame may stay
// visible under a sheet, so visibilitychange alone is not enough: while paused nothing renders,
// no sound plays and the keke stops. The socket stays open; the seat is held server-side anyway.
const listeners = new Set<(paused: boolean) => void>();
let paused = false;

export const isPaused = (): boolean => paused;

export function setPaused(on: boolean): void {
  if (paused === on) return;
  paused = on;
  for (const l of listeners) l(on);
}

export function onPause(cb: (paused: boolean) => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
